import { AI_COACH_CONTENT_FETCH_STARTED } from '../../types';
export const startAiCoachContentFetch = _ref => {
  let {
    exerciseId
  } = _ref;
  return {
    exerciseId,
    type: AI_COACH_CONTENT_FETCH_STARTED
  };
};